<template>
  <v-card
      flat
      v-if="items.length > 0"
      rounded="0"
      class="mx-auto mt-4"
      max-width="800"
      mim-width="350"
  >
    <v-container fluid>
      <v-row class="ma-0">
        <v-col cols="2" class="pa-0 text-start align-self-center">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            주문번호
          </v-card-text>
        </v-col>
        <v-col cols="2"></v-col>
        <v-col cols="8" class="pa-0">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            {{orderInfo.sale_date}}-{{orderInfo.bill_no}}-{{orderInfo.upjang_code}}
          </v-card-text>
        </v-col>
      </v-row>

      <v-row class="ma-0">
        <v-col cols="2" class="pa-0 text-start align-self-center">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            주문일자
          </v-card-text>
        </v-col>
        <v-col cols="2"></v-col>
        <v-col cols="8" class="pa-0">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            {{formatDate(orderInfo.sale_date)}}
          </v-card-text>
        </v-col>
      </v-row>

      <v-row class="ma-0">
        <v-col cols="2" class="pa-0 text-start align-self-center">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            주문상태
          </v-card-text>
        </v-col>
        <v-col cols="2"></v-col>
        <v-col cols="8" class="pa-0">
          <div v-if="orderInfo.order_stat === '001' || orderInfo.order_stat === '002' || orderInfo.order_stat === '003'">
            <v-chip
                color="primary"
                size="small">
              {{orderInfo.order_stat_name}}
            </v-chip>
          </div>
          <div v-if="orderInfo.order_stat === '005'">
            <v-chip
                color="red"
                size="small">
              {{orderInfo.order_stat_name}}
            </v-chip>
          </div>
          <div v-if="orderInfo.order_stat === '004' || orderInfo.order_stat === '006'">
            <v-chip
                color="grey-darken-3"
                size="small">
              {{orderInfo.order_stat_name}}
            </v-chip>
          </div>
        </v-col>
      </v-row>

    </v-container>

    <v-divider class="mt-2 mb-2"></v-divider>

    <v-container fluid>
      <v-row class="ma-0">
        <v-col cols="2" class="pa-0 text-start align-self-center">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            주문자
          </v-card-text>
        </v-col>
        <v-col cols="2"></v-col>
        <v-col cols="8" class="pa-0">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            {{orderInfo.parcel_order_name}}
          </v-card-text>
        </v-col>
      </v-row>

      <v-row class="ma-0">
        <v-col cols="2" class="pa-0 text-start align-self-center">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            연락처
          </v-card-text>
        </v-col>
        <v-col cols="2"></v-col>
        <v-col cols="8" class="pa-0">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            {{orderInfo.parcel_order_hp_no}}
          </v-card-text>
        </v-col>
      </v-row>

      <v-row class="ma-0">
        <v-col cols="2" class="pa-0 text-start align-self-center">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            수령방법
          </v-card-text>
        </v-col>
        <v-col cols="2"></v-col>
        <v-col cols="8" class="pa-0">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            {{orderInfo.select_rcv_name}}
          </v-card-text>
        </v-col>
      </v-row>

      <v-row class="ma-0">
        <v-col cols="2" class="pa-0 text-start align-self-center">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            결제수단
          </v-card-text>
        </v-col>
        <v-col cols="2"></v-col>
        <v-col cols="8" class="pa-0">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            {{orderInfo.select_calc_name}}
          </v-card-text>
        </v-col>
      </v-row>
    </v-container>

    <v-divider class="mt-2 mb-2"></v-divider>

    <v-container fluid>
      <v-row class="ma-0">
        <v-col cols="2" class="pa-0 text-start align-self-center">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            받는사람
          </v-card-text>
        </v-col>
        <v-col cols="2"></v-col>
        <v-col cols="8" class="pa-0">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            {{orderInfo.parcel_receipt_name}}
          </v-card-text>
        </v-col>
      </v-row>

      <v-row class="ma-0">
        <v-col cols="2" class="pa-0 text-start align-self-center">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            연락처
          </v-card-text>
        </v-col>
        <v-col cols="2"></v-col>
        <v-col cols="8" class="pa-0">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            {{orderInfo.parcel_receipt_hp_no}}
          </v-card-text>
        </v-col>
      </v-row>

      <div v-if="orderInfo.select_rcv === '001'">
        <v-row class="ma-0">
          <v-col cols="2" class="pa-0 text-start align-self-center">
            <v-card-text class="pa-0 font-weight-bold text-body-2">
              객실주소
            </v-card-text>
          </v-col>
          <v-col cols="2"></v-col>
          <v-col cols="8" class="pa-0">
            <v-card-text class="pa-0 font-weight-bold text-body-2">
              {{orderInfo.select_rcv_outlet}}
            </v-card-text>
          </v-col>
        </v-row>
      </div>

      <div v-if="orderInfo.select_rcv === '002'">
        <v-row class="ma-0">
          <v-col cols="2" class="pa-0 text-start align-self-center">
            <v-card-text class="pa-0 font-weight-bold text-body-2">
              수령시간
            </v-card-text>
          </v-col>
          <v-col cols="2"></v-col>
          <v-col cols="8" class="pa-0">
            <v-card-text class="pa-0 font-weight-bold text-body-2">
              {{orderInfo.pick_up_time}}
            </v-card-text>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="2" class="pa-0 text-start align-self-center">
            <v-card-text class="pa-0 font-weight-bold text-body-2">
              요청사항
            </v-card-text>
          </v-col>
          <v-col cols="2"></v-col>
          <v-col cols="8" class="pa-0">
            <v-card-text class="pa-0 font-weight-bold text-body-2">
              {{orderInfo.request_msg}}
            </v-card-text>
          </v-col>
        </v-row>
      </div>

      <div v-if="orderInfo.select_rcv === '003'">
        <v-row class="ma-0">
          <v-col cols="2" class="pa-0 text-start align-self-center">
            <v-card-text class="pa-0 font-weight-bold text-body-2">
              배송지
            </v-card-text>
          </v-col>
          <v-col cols="2"></v-col>
          <v-col cols="8" class="pa-0">
            <v-card-text class="pa-0 font-weight-bold text-body-2">
              ({{orderInfo.parcel_post_no}}) {{orderInfo.parcel_addr}} {{orderInfo.parcel_addr_detail}}
            </v-card-text>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="2" class="pa-0 text-start align-self-center">
            <v-card-text class="pa-0 font-weight-bold text-body-2">
              배송정보
            </v-card-text>
          </v-col>
          <v-col cols="2"></v-col>
          <v-col cols="8" class="pa-0">
            <v-card-text class="pa-0 font-weight-bold text-body-2">
              {{ orderInfo.delivery_corp_name || '-' }}
            </v-card-text>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="2" class="pa-0 text-start align-self-center">
            <v-card-text class="pa-0 font-weight-bold text-body-2">
              배송번호
            </v-card-text>
          </v-col>
          <v-col cols="2"></v-col>
          <v-col cols="8" class="pa-0">
            <v-card-text class="pa-0 font-weight-bold text-body-2">
              {{ orderInfo.delivery_no || '-' }}
            </v-card-text>
          </v-col>
        </v-row>
      </div>

      <div v-if="orderInfo.select_rcv === '004'">
        <v-row class="ma-0">
          <v-col cols="3" class="pa-0 text-start align-self-center">
            <v-card-text class="pa-0 font-weight-bold text-body-2">
              테이블번호
            </v-card-text>
          </v-col>
          <v-col cols="1"></v-col>
          <v-col cols="8" class="pa-0">
            <v-card-text class="pa-0 font-weight-bold text-body-2">
              {{orderInfo.table_no}}
            </v-card-text>
          </v-col>
        </v-row>
      </div>

      <div v-if="orderInfo.select_rcv === '005'">
        <v-row class="ma-0">
          <v-col cols="2" class="pa-0 text-start align-self-center">
            <v-card-text class="pa-0 font-weight-bold text-body-2">
              픽업시간
            </v-card-text>
          </v-col>
          <v-col cols="2"></v-col>
          <v-col cols="8" class="pa-0">
            <v-text-field v-model="orderInfo.pick_up_time"
                          type="time"
                          class="pa-0" density="compact" variant="outlined" single-line hide-details></v-text-field>
          </v-col>
        </v-row>
        <v-row class="ma-0">
          <v-col cols="2" class="pa-0 text-start align-self-center">
            <v-card-text class="pa-0 font-weight-bold text-body-2">
              요청사항
            </v-card-text>
          </v-col>
          <v-col cols="2"></v-col>
          <v-col cols="8" class="pa-0">
            <v-text-field
                v-model="orderInfo.request_msg"
                class="pa-0" density="compact" variant="outlined" single-line hide-details></v-text-field>
          </v-col>
        </v-row>
      </div>

      <v-row class="ma-0">
        <v-col cols="2" class="pa-0 text-start align-self-center">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            추천인
          </v-card-text>
        </v-col>
        <v-col cols="2"></v-col>
        <v-col cols="8" class="pa-0">
          <v-card-text class="pa-0 font-weight-bold text-body-2">
            {{orderInfo.parcel_recm_name || '-'}}
          </v-card-text>
        </v-col>
      </v-row>
    </v-container>

    <v-divider class="mt-2 mb-2"></v-divider>

    <v-container fluid>
      <v-row class="pa-3 pb-4">
        <v-col cols="12" class="pa-0">
          <v-card-text class="pa-0 text-body-1 font-weight-bold">{{orderInfo.upjang_name}}</v-card-text>
        </v-col>
      </v-row>

      <v-card class="pa-2 mt-2" v-for="item in items" color="grey-lighten-3" variant="flat">
        <v-container v-if="item.menu_code === 'G99634'" fluid>
          <v-row class="pa-1">
            <v-col cols="8" class="pa-0">
              <v-card-text class="pa-0 text-body-1 font-weight-bold">배송비</v-card-text>
            </v-col>
            <v-col cols="4" class="pa-0 text-end">
              <v-card-text class="pa-0 text-body-1 font-weight-bold">{{ formatAmt(item.sale_amt) }}</v-card-text>
            </v-col>
          </v-row>
        </v-container>

        <v-container v-else fluid>
          <v-row class="pa-1">
            <v-col cols="12" class="pa-0">
              <v-card-text class="pa-0 text-body-1 font-weight-bold">{{item.menu_name}}</v-card-text>
            </v-col>
          </v-row>
          <v-row class="pl-1 pr-1 text-end">
            <v-col cols="8" class="pa-0">
              <v-card-text class="pa-0 text-caption">{{formatAmt(item.unit_price)}} X {{item.sale_qty}}개</v-card-text>
            </v-col>
            <v-col cols="4" class="pa-0">
              <v-card-text class="pa-0 text-body-2 font-weight-bold">{{formatAmt(item.unit_price * item.sale_qty)}}</v-card-text>
            </v-col>
          </v-row>
          <v-row v-if="item.dc_amt > 0" class="pl-1 pr-1 text-end">
            <v-col cols="8" class="pa-0">
              <v-card-text class="pa-0 text-red text-caption">할인</v-card-text>
            </v-col>
            <v-col cols="4" class="pa-0">
              <v-card-text class="pa-0 text-red text-body-2">{{formatAmt(item.dc_amt)}}</v-card-text>
            </v-col>
          </v-row>
          <v-row class="pl-1 pr-1 text-end">
            <v-col cols="12" class="pa-0">
              <v-card-text class="pa-0 text-body-1 font-weight-bold">{{formatAmt(item.sale_amt)}}</v-card-text>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>

    <v-container class="pt-0" fluid>
      <v-card class="pa-2" color="grey-lighten-3" variant="flat">
        <v-container fluid>
          <v-row class="pa-1 text-end">
            <v-col cols="8" class="pa-0 text-start">
              <v-card-text class="pa-0 text-body-1 font-weight-bold">최종 결제 금액</v-card-text>
            </v-col>
            <v-col cols="4" class="pa-0 text-end">
              <v-card-text class="pa-0 text-body-1 font-weight-bold">{{formatAmt(orderInfo.sale_amt) || '-'}}</v-card-text>
            </v-col>
          </v-row>
        </v-container>
      </v-card>

    </v-container>

    <!--  주문요청일때만 취소가능  -->
    <v-container class="mb-3" v-if="orderInfo.order_stat === '001'">
      <v-row>
        <v-col cols="12">
          <v-btn
              class="w-100 bg-primary"
              size="large"
              @click="cancelOrderInfo(false)">
            주문취소
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-container class="mb-3" v-if="orderInfo.order_stat === '002' || orderInfo.order_stat === '004'">
      <v-row>
        <v-col cols="12">
          <v-btn
              class="w-100 bg-primary"
              size="large"
              @click="cancelOrderInfo(true)">
            취소요청
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

  </v-card>

  <MobileFooter></MobileFooter>
</template>

<script>
import authStore from "@/store/auth";
import {order} from "@/api";
import commonStore from "@/store/common";
import MobileFooter from "@/components/common/MobileFooter";

export default {
  name: "OrderDetail",
  components: {MobileFooter},
  data () {
    return {
      isAuth: false,
      saleDate: '',
      billNo: '',
      upjangCode: '',
      items: [],
      orderInfo: {},
      orderPayInfo: {},
      totalProductPrice: 0,
    }
  },
  computed: {
    isAuth() {
      return authStore.state.authInfo.token !== null;
    },
  },
  created() {
    this.isAuth = authStore.state.authInfo.token !== null
    this.saleDate = this.$route.params.saleDate
    this.billNo = this.$route.params.billNo
    this.upjangCode = this.$route.params.upjangCode
    this.validationCheck()
    this.getOrderInfo()
  },
  methods: {
    validationCheck() {
      if (!this.isAuth) {
        alert("잘못된 접근입니다.")
        this.$router.push('/')
        return
      }
    },
    getOrderInfo() {
      order.getOrderInfo(commonStore.state.common.corpCode, this.saleDate
          , this.billNo, this.upjangCode)
          .then(data => {
            console.log(data)
            if (data.data) {
              if (!data.data.order_info.sale_date && !data.data.order_info.bill_no && !data.data.order_info.upjang_code) {
                alert("유효하지 않은 구매 정보 입니다.")
                this.$router.push('/order/history')
                return
              }

              this.items = data.data.order_details
              this.orderInfo = data.data.order_info
              this.orderPayInfo = data.data.order_pay_info
              this.totalProductPrice = 0

              this.items.forEach(item => {
                this.totalProductPrice += parseInt(item.sale_amt,10)
              })
            }
          })
          .catch(err => {
            if (err.isAlert) {
              alert(err.result.error_message)
            }
          })
    },
    cancelOrderInfo(cancelRequest) {
      const request = {
        corp_code: this.orderInfo.corp_code,
        sale_date: this.orderInfo.sale_date,
        upjang_code: this.orderInfo.upjang_code,
        bill_no: this.orderInfo.bill_no,
        cancel_request: cancelRequest,
        trade_no: this.orderPayInfo.trade_no,
        sale_amt: this.orderInfo.sale_amt
      };

      order.cancelOrderInfo(request)
          .then(data => {
            console.log(data)
            if (data.data) {
              if(data.data.order_stat ==='005') {
                alert("주문건이 취소요청 되었습니다.\n관리자 확인 후 취소처리됩니다.")
              } else if(data.data.order_stat ==='006') {
                alert("고객님의 주문이 정상적으로 취소되었습니다.\n감사합니다.")
              } else {
                alert("취소처리 중 문제가 발생하였습니다.")
              }
              this.$router.push('/order/history')
            }
          })
          .catch(err => {
            if (err.isAlert) {
              alert(err.result.error_message)
            }
          })
    },
  }
}
</script>

<style scoped>

</style>